<template>
    <div class='demo'>
      <van-button type="info" @click="gotoWx" block>关注公众号</van-button>
      <wx-open-audio
      
      title="追光者"
      singer="追光者"
      episode="追光者"
      src="https://o-yzx.bysjy.com.cn/yxdczh0000000186/mates/202104/yxz607f9f6a193b8.mp3"
      cover="https://o-yzx.bysjy.com.cn/yxdczh0000000186/mates/202101/yxz5ffbb04bcc842.png"
    ></wx-open-audio>

      <wx-open-subscribe template="rfagCC6fQX3yATxoyseDnZzRcP96eVbNIh79wMfoPWE,Lhj29QhCqpMG6E2YJkkOt1AS24LY6ntJcMz-2ZECqFU" id="subscribe-btn">
        
        <template>
          <button class="subscribe-btn">
            一次性模版消息订阅              
          </button>
        </template>
      </wx-open-subscribe>
    </div>
</template>
<script>
import {Image as VanImage,Button,Popup,Divider,Toast ,Field,Checkbox,Icon,ActionSheet,ImagePreview,Dialog,Loading,Swipe, SwipeItem, CountDown} from 'vant';
import login from '@/components/common/login';
import wx from 'weixin-js-sdk'
import VConsole from "vconsole";
var vConsole = new VConsole();

export default {
        name: "subscribe",
        components:{
           [Button.name]:Button,
        },
        data(){
            return {
                bodyShow: false,
            }
        },
        mounted() {
            // this.util.hideOptionMenu()
            this.init()
            this.$(document).attr('title','测试')
            console.log('this.util.is_gate_user',this.util.is_gate_user)
            console.log('this.util.is_gate_user',this.util.is_gate_user)
            setTimeout(() => {
              var btn = document.getElementById('subscribe-btn');
              btn.addEventListener('success', function (e) {            
                console.log('success', e.detail);
              });   
              btn.addEventListener('error',function (e) {             
                console.log('fail', e.detail);
              });
            }, 1000);
            
        },
        methods:{
            init(){
                this.util.jweixin(function (wx) {
                    
                });
            },
            gotoWx(){
              window.location.href = "https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=MzIzODAyOTY5OQ==#wechat_redirect"
            }
        }
    }

</script>
<style scoped>
.subscribe-btn {
    color: #fff;
    background-color: #07c160;
  }
</style>